import { Modal } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import Styles from "./ConGenLIstingModal.module.css";

import { Close, X } from "@mui/icons-material";
import { ReactComponent as DeleteIcon } from "../../../assets/images/RemoveIcon.svg";
import { ReactComponent as AddIcon } from "../../../assets/images/AdditionIcon.svg";
import DateInput from "../../../commons/Inputs/DateInputBailateral/DateInput";
import TimeInput from "../../../commons/Inputs/TimeInputBailateral/TimeInput";
import TextInput from "../../../commons/Inputs/TextInput/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Upload } from "../../../assets/images/uploadIcon.svg";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  getAllRegion,
  getAllVoltage,
} from "../../../Services/ApiCalling/PublicApi";
import SelectInput from "../../../commons/Inputs/Select/SelectInput";
import { formatDateElement } from "../../../commons/FormatDate";
import Fileupload from "../../../commons/Inputs/FileUpload/Fileupload";
import FileDownloadIcon from "../../../assets/images/Download_brand.svg";
import IntradayListingConsumer from "../../../assets/docs/Listing Bilateral - Intraday.xlsx";
import IntradayListingGenerator from "../../../assets/docs/Listing Bilateral Generator- Intraday.xlsx";
import NextDayListingConsumer from "../../../assets/docs/Listing Bilateral - Next day.xlsx";
import NextDayListingGenerator from "../../../assets/docs/Listing Bilateral Generator- Next day.xlsx";
import Next7DayListingConsumer from "../../../assets/docs/Listing Bilateral - Upto T+7 Days.xlsx";
import Next7DayListingGenerator from "../../../assets/docs/Listing Bilateral Generator- Upto T+7 Days.xlsx";
import GreaterThan7DaysListingConsumer from "../../../assets/docs/Listing Bilateral - More that T+7 Days.xlsx";
import GreaterThan7DaysListingGenerator from "../../../assets/docs/Listing Bilateral Generator- More that T+7 Days.xlsx";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import { withdrawBid } from "../../../Services/BuySell/Listing";
import { fetchCounterPartList } from "../../../Redux/Slices/CapacitySlice";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal";
import { formatSlotTime } from "../../../helpers/dateFormat";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";

const deliveryTypeList = [
  { id: 1, name: "Intrastate", value: false },
  { id: 2, name: "InterState", value: true },
];

const injDrawl = [
  { id: 1, name: "ISTS" },
  { id: 2, name: "STU" },
  // { id: 3, name: "Ex-Bus-Bar" },
];

const energyReqList = [
  { id: 1, name: "Any", value: "ANY" },
  { id: 2, name: "RE", value: "RENEWABLE" },
  { id: 3, name: "Non-RE", value: "NON_RENEWABLE" },
];
export const EnergyRateList = [
  { id: 1, name: "DAM+" },
  { id: 2, name: "DAM-" },
  { id: 3, name: "Fixed" },
];

// Safe cell reader
const readCell = (cell) => {
  if (!cell) return "";
  const v = cell.value;
  if (v === null || v === undefined) return "";
  if (typeof v === "object" && v.text) return v.text;
  return v;
};

const isValidDateValue = (d) => d instanceof Date && !isNaN(d);
// Convert Excel serial date to ISO yyyy-mm-dd
const excelDateToISO = (serial) => {
  if (!serial && serial !== 0) return "";
  const utcDays = Math.floor(serial - 25569);
  const utcValue = utcDays * 86400;
  const date = new Date(utcValue * 1000);
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const d = String(date.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const isValidTime = (timeStr) => {
  if (!timeStr) return true; // Empty time is handled by required validation
  const [hours, minutes] = timeStr.split(":").map(Number);
  if (hours === 24 && minutes > 0) return false;
  if (hours > 24) return false;
  return true;
};

const combineDateTime = (date, time) => {
  if (!date || !time) return null;
  const d = date instanceof Date ? new Date(date) : new Date(date);
  const [hr, min] = time.split(":").map(Number);
  d.setHours(hr || 0, min || 0, 0, 0);
  return d;
};

const ConGenListingModal = ({
  open,
  handleClose,
  handleSubmit,
  editId,
  type,
  loading,
  data,
  handleWithdraw,
  handleHold,
  handleResume,
  withdrawLoading,
  holdLoading,
  resumeLoading,
  editConnectionRequest,
  activeCounrterId,
  directConnect,
  handleSubmitLoading,
}) => {
  const activeRegion = useSelector(
    (state) => state?.activeRegion?.activeRegion,
  );
  const [withdrawBidLoading, setWithdrawBidLoading] = useState(false);
  const [confirmAddListingPayload, setConfirmAddListingPayload] =
    useState(null);
  const token = useSelector((state) => state?.persistedReducer?.token);
  const user = useSelector((state) => state?.persistedReducer);
  const [confirmAddListingModalOpen, setConfirmAddListingModalOpen] =
    useState(false);
  const userData = useSelector((state) => state?.persistedReducer?.user);
  const activeListing = useSelector((state) => {
    return state?.CapacitySlice?.counterList;
  });
  const activeGeneratorId = useSelector(
    (state) => state?.persistedReducer?.user?.activeGeneratorId,
  );
  const activeGeneratorData = userData?.generators?.find(
    (gen) => gen.generatorId === activeGeneratorId,
  );
  console.log("activeGeneratorData", activeGeneratorData);
  const activeRole = user?.user?.activeRole;
  const energyList = useSelector(
    (state) => state?.publicSlice?.publicEnergyType,
  );
  console.log("🚀 ~ ConGenListingModal ~ energyList:", energyList);
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  const canUpdateListing = activeListing?.some(
    (listing) =>
      // listing.status === "APPROVED" ||
      // listing.status === "PENDING" ||
      listing.status === "TERMS_INITIATED" ||
      listing.status === "TERMS_ACCEPTED" ||
      listing.status === "AGREEMENT_ACCEPTED",
  );

  // State
  const [requirements, setRequirements] = useState([
    {
      startDate: null,
      startTime: "",
      endDate: null,
      endTime: "",
      energyRate: "",
      quantity: "",
      rtc: false,
      energyRateType: { id: 1, name: "DAM+" },
    },
  ]);
  console.debug("requirements", requirements);
  const [voltage, setVoltage] = useState({
    level: user?.userDetails?.discomVoltage,
  });
  const [injectDrawl, setInjectDrawl] = useState("");
  const [deliveryType, setDeliveryType] = useState({});
  const [region, setRegion] = useState({});
  const [energyReq, setEnergyReq] = useState({});
  const [energyType, setEnergyType] = useState({});
  const [termsExpDate, setTermsExpDate] = useState(null);
  const [initialMargin, setInitialMargin] = useState("");
  const [emd, setEmd] = useState("");
  const [paymentSecurity, setPaymentSecurity] = useState("");
  const [termsExpTime, setTermsExpTime] = useState("");
  const [listingExpDate, setListingExpDate] = useState(null);
  const [listingExpTime, setListingExpTime] = useState("");
  const [comment, setComment] = useState("");
  const [voltageList, setVoltageList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [generalTermsConditions, setGeneralTermsConditions] = useState(null);
  const [acceptSystemTerms, setAcceptSystemTerms] = useState(false);
  const [termsError, setTermsError] = useState("");
  const [errors, setErrors] = useState({});
  const [confirmEditModalOpen, setConfirmEditModalOpen] = useState(false);
  const [confirmHoldModalOpen, setConfirmHoldModalOpen] = useState(false);
  const [confirmResumeModalOpen, setConfirmResumeModalOpen] = useState(false);

  const [entityName,setEntityName] = useState("")

  const [rateType, setRateType] = useState("open");
  const [
    confirmWithdrawConnectionModalOpen,
    setConfirmWithdrawConnectionModalOpen,
  ] = useState(false);
  const [confirmWithdrawModalOpen, setConfirmWithdrawModalOpen] =
    useState(false);

  const [reqStage, setReqStage] = useState(null);
  console.log("🚀 ~ ConGenListingModal ~ reqStage:", reqStage);
  const [isIntra, setIsIntra] = useState(true);
  const dispatch = useDispatch();
  const onHold = data?.status === "HOLD" && editId;

  // Effects

  useEffect(() => {
    if (type === "add") {
      setRequirements((prev) =>
        prev.map((req) => ({
          ...req,
          energyRateType: req.energyRateType || { id: 1, name: "DAM+" },
        })),
      );
    }
  }, [type]);

  useEffect(() => {
    if (
      reqStage === "intraday" ||
      reqStage === "nextday" ||
      reqStage === "upto_7"
    ) {
      setInitialMargin(105);
      setEmd(30000);
      setPaymentSecurity(1);
    } else if (reqStage === "greater_7") {
      // Don't reset values for upto_7 and greater_7 if they're already set from Excel
      // Only set default empty values if they're currently empty
      // if (!initialMargin && !emd && !paymentSecurity) {
      //   setInitialMargin("");
      //   setEmd("");
      //   setPaymentSecurity("");
      // }
      setPaymentSecurity(4);
      setInitialMargin(100);
      setEmd(0);
    } else {
      setInitialMargin("");
      setEmd("");
      setPaymentSecurity("");
    }
  }, [reqStage, activeRole]);

  useEffect(() => {
    if (reqStage === "greater_7" || reqStage === "upto_7") {
      setListingExpDate(null);
      setListingExpTime("");
    }
  }, [reqStage]);

  useEffect(() => {
    if (
      activeRole === "GENERATOR" &&
      !window.location.pathname.includes("search_listing")
    ) {
      const energyReq = energyReqList.find(
        (req) => req.value === activeGeneratorData?.generationType,
      );
      console.log("🚀 ~ ConGenListingModal ~ energyReq:", energyReq);
      const energyType = energyList.find(
        (ele) => ele.type === activeGeneratorData?.energyTypeName,
      );

      setEnergyReq(energyReq);
      setEnergyType(energyType);
    }
    if (
      activeRole === "CONSUMER" &&
      !window.location.pathname.includes("search_listing")
    ) {
      setEnergyReq({ id: 1, name: "Any" });
      setEnergyType({ id: 16, genType: "RENEWABLE", type: "Any" });
    }
    const region = regionList.find((ele) => ele.name === activeRegion);
    setRegion(region);
  }, [activeGeneratorData, activeRole, energyList, regionList, activeRegion]);

  useEffect(() => {
    // Helper functions

    function parseDate(dateStr) {
      if (!dateStr) return null;
      return new Date(dateStr);
    }
    function isSameDay(date1, date2) {
      return (
        date1 &&
        date2 &&
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    }

    if (editId || editConnectionRequest || type === "duplicate") {
      // Calculate reqStage from data
      if (data && data.slots && data.slots.length > 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const start = parseDate(data.slots[0]?.dateStartAt);
        const end = parseDate(data.slots[0]?.dateEndAt);

        // if (start && end) {
        //   if (isSameDay(start, today) && isSameDay(end, today)) {
        //     setReqStage("intraday");
        //   } else if (isSameDay(start, tomorrow) && isSameDay(end, tomorrow)) {
        //     setReqStage("nextday");
        //   } else {
        //     const diffStart = (start - today) / (1000 * 60 * 60 * 24);
        //     const diffEnd = (end - today) / (1000 * 60 * 60 * 24);

        //     // Calculate the duration of the requirement
        //     const duration =
        //       Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

        //     // If dates are in the past or current, determine stage by duration
        //     if (diffStart < 0 || diffEnd < 0) {
        //       if (duration <= 1) {
        //         setReqStage("intraday");
        //       } else if (duration <= 7) {
        //         setReqStage("upto_7");
        //       } else {
        //         setReqStage("greater_7");
        //       }
        //     } else {
        //       // Future dates
        //       if (diffStart >= 0 && diffEnd >= 0 && diffEnd <= 7) {
        //         setReqStage("upto_7");
        //       } else if (diffEnd > 7) {
        //         setReqStage("greater_7");
        //       } else {
        //         setReqStage("upto_7"); // Changed from "" to "upto_7" as default
        //       }
        //     }
        //   }
        // } else {
        //   setReqStage("");
        // }
      }
      return;
    }

    if (type !== "add") {
      setReqStage("");
    } else {
      setReqStage("greater_7");
    }
  }, [data, editConnectionRequest, editId, type]);

  useEffect(() => {
    if (reqStage === "intraday") {
      const today = new Date();
      // Calculate minimum allowed start time (current time + 3 hours)
      const now = new Date();
      const minStart = new Date(now.getTime() + 3 * 60 * 60 * 1000);

      // Round minutes up to next 00, 15, 30, or 45
      let min = minStart.getMinutes();
      let roundedMin = [0, 15, 30, 45].find((m) => m > min);
      if (roundedMin === undefined) {
        // If minutes > 45, go to next hour
        minStart.setHours(minStart.getHours() + 1);
        roundedMin = 0;
      }
      minStart.setMinutes(roundedMin, 0, 0);

      let minStartTime = `${minStart
        .getHours()
        .toString()
        .padStart(2, "0")}:${minStart
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;

      setRequirements((prev) =>
        prev.map((req) => ({
          ...req,
          startDate: today,
          endDate: today,
          startTime: minStartTime,
          endTime: "24:00",
          rtc: false, // Reset RTC
        })),
      );
    } else if (reqStage === "nextday") {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setRequirements((prev) =>
        prev.map((req) => ({
          ...req,
          startDate: tomorrow,
          endDate: tomorrow,
          startTime: "00:00",
          endTime: "24:00",
          rtc: false, // Reset RTC
        })),
      );
    } else if (reqStage === "upto_7") {
      setRequirements((prev) =>
        prev.map((req) => ({
          ...req,
          startDate: null,
          endDate: null,
          startTime: "",
          endTime: "",
          rtc: false, // Reset RTC
        })),
      );
    } else {
      setRequirements((prev) =>
        prev.map((req) => ({
          ...req,
          startDate: null,
          endDate: null,
          startTime: "",
          endTime: "",
          rtc: false, // Reset RTC for any other case
        })),
      );
    }
  }, [reqStage]);

  useEffect(() => {
    if (data) {
      setComment(data.comment || "");
      if (
        !window.location.pathname.includes("/search_listing") ||
        data.listingType === "GREATER_THAN_SEVEN_DAYS"
      ) {
        setInitialMargin(data.initialMargin || "");
        setEmd(data.emd || "");
        setPaymentSecurity(data.paymentSecurity || "");
      }
      setListingExpDate(
        data.listingExpDate ? new Date(data.listingExpDate) : null,
      );
      setListingExpTime(data.listingExpTime || "");
      setTermsExpDate(data.termsExpDate ? new Date(data.termsExpDate) : null);
      setTermsExpTime(data.termsExpTime || "");
      setGeneralTermsConditions(
        directConnect ? null : data.termsDocumentId || null,
      );
      setReqStage(
        data.listingType === "INTRA_DAY"
          ? "intraday"
          : data.listingType === "NEXT_DAY"
            ? "nextday"
            : data.listingType === "UPTO_SEVEN_DAYS"
              ? "upto_7"
              : data.listingType === "GREATER_THAN_SEVEN_DAYS"
                ? "greater_7"
                : "",
      );

      setEnergyReq(
        energyReqList?.find(
          (req) =>
            req?.name?.toLowerCase() ===
              (data?.energySourceType || "").toLowerCase() ||
            (req?.value &&
              req?.value.toLowerCase() ===
                (data?.energySourceType || "").toLowerCase()),
        ) || {},
      );

      setEnergyType(
        energyList?.find(
          (type) =>
            type?.name?.toLowerCase() ===
              (data?.energyFuelType || "").toLowerCase() ||
            type?.type?.toLowerCase() ===
              (data?.energyFuelType || "").toLowerCase(),
        ) || {},
      );

      setDeliveryType(
        deliveryTypeList.find((type) => type.value === data.isInterstate) || {},
      );

      setInjectDrawl(
        data.deliveryType === "STU"
          ? { id: 2, name: "STU" }
          : { id: 1, name: "ISTS" } || {},
      );
      // setInjectDrawl(
      //   data.isExBusBar
      //     ? { id: 3, name: "Ex-Bus-Bar" }
      //     : !data.isInterstate
      //     ? { id: 2, name: "STU" }
      //     : { id: 1, name: "ISTS" } || {}
      // );

      setVoltage(
        voltageList.find(
          (voltage) =>
            voltage.name?.toString().trim().toLowerCase() ===
            (data.voltageLevel || "").toString().trim().toLowerCase(),
        ) || { id: "", name: data.voltageLevel },
      );

      setRequirements(
        Array.isArray(data.slots)
          ? data.slots.map((slot) => {
              const startTime = slot.slotStartAt || "";
              const endTime = slot.slotEndAt || "";
              // Auto-set RTC if times are 00:00 and 24:00/23:59
              const shouldSetRtc =
                startTime === "00:00" &&
                (endTime === "24:00" || endTime === "23:59");

              // Parse energyRateStr to extract numeric value and set energy rate type
              let energyRate = "";
              let parsedEnergyRateType = { id: 1, name: "DAM+" }; // Default

              if (slot?.energyRateStr) {
                const rateStr = slot.energyRateStr.toString().trim();

                if (rateStr.startsWith("DAM+")) {
                  // Extract number after DAM+
                  energyRate = rateStr.replace("DAM+", "").trim();
                  parsedEnergyRateType = { id: 1, name: "DAM+" };
                } else if (rateStr.startsWith("DAM-")) {
                  // Extract number after DAM-
                  energyRate = rateStr.replace("DAM-", "").trim();
                  parsedEnergyRateType = { id: 2, name: "DAM-" };
                }
              } else if (slot.sellingCost || slot.landingCost) {
                // If no energyRateStr but has sellingCost/landingCost, treat as Fixed
                energyRate = slot.sellingCost || slot.landingCost || "";
                parsedEnergyRateType = { id: 3, name: "Fixed" };
              }

              return {
                startDate: slot.dateStartAt ? new Date(slot.dateStartAt) : null,
                endDate: slot.dateEndAt ? new Date(slot.dateEndAt) : null,
                startTime: startTime,
                endTime: endTime,
                energyRate: energyRate,
                quantity: slot.purchaseEnergy || slot.sellEnergy || "",
                rtc: shouldSetRtc,
                energyRateType: parsedEnergyRateType, // Add this
              };
            })
          : [
              {
                startDate: null,
                startTime: "",
                endDate: null,
                endTime: "",
                energyRate: "",
                quantity: "",
                rtc: false,
                energyRateType: { id: 1, name: "DAM+" }, // Add this
              },
            ],
      );

      if (type === "search") {
        // First, try to use listingType if available
        if (data?.listingType) {
          console.log("data.listingType", data.listingType);
          const reqStageFromListingType =
            data.listingType === "INTRA_DAY"
              ? "intraday"
              : data.listingType === "NEXT_DAY"
                ? "nextday"
                : data.listingType === "UPTO_SEVEN_DAYS"
                  ? "upto_7"
                  : data.listingType === "GREATER_THAN_SEVEN_DAYS"
                    ? "greater_7"
                    : "";

          if (reqStageFromListingType) {
            setReqStage(reqStageFromListingType);

            // Set payment security for intraday
            if (reqStageFromListingType === "intraday") {
              setPaymentSecurity(1);
            }
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    data,
    energyList,
    voltageList,
    regionList,
    type,
    directConnect,
    activeRole,
    // energyRateType?.id,
  ]);

  // useEffect(() => {
  //   if (injectDrawl?.name?.toLowerCase() === "ists") {
  //     setDeliveryType({ id: 2, name: "InterState", value: true });
  //   } else if (injectDrawl?.name?.toLowerCase() === "stu") {
  //     setDeliveryType({ id: 1, name: "Intrastate", value: false });
  //   }
  //   // Don't auto-set for Ex-Bus-Bar
  // }, [injectDrawl]);

  const consumerGeneratorId = useSelector((state) => {
    const activeMain =
      state?.persistedReducer?.user?.activeGeneratorId ||
      state?.persistedReducer?.user?.activeConsumerId;
    return activeMain;
  });

  const consumerList = useSelector(
    (state) => state?.CapacitySlice?.fetchSideBarList?.consumers,
  );

  const generatorList = useSelector(
    (state) => state?.CapacitySlice?.fetchSideBarList?.generators,
  );

  const isTrader = useSelector((state) => state?.persistedReducer);

  const trader = useSelector((state) => state?.persistedReducer);

  const traderParent = trader?.roles?.includes("TRADER");

  function getMaxQuantity() {
    if (activeRole === "CONSUMER") {
      const consumer = consumerList?.find(
        (c) => c.consumerId === consumerGeneratorId,
      );
      return consumer?.maxCapDrawl;
    }
    if (activeRole === "GENERATOR") {
      const generator = generatorList?.find(
        (g) => g.generatorId === consumerGeneratorId,
      );

      return generator?.maxInjCap;
    }
  }

  const getFilteredVoltageList = (deliveryType, voltageList) => {
    if (!voltageList || voltageList.length === 0) return [];

    if (deliveryType?.name === "InterState") {
      // For ISTS, show 132 kV and above
      return voltageList.filter((voltage) => {
        const levelNum = parseFloat(voltage.name);
        return !isNaN(levelNum) && levelNum >= 132;
      });
    }

    if (deliveryType?.name === "Intrastate") {
      // For STU, show below 132 kV
      return voltageList.filter((voltage) => {
        const levelNum = parseFloat(voltage.name);
        // Include LT and voltages below 132
        return voltage.name === "LT" || (!isNaN(levelNum) && levelNum < 132);
      });
    }

    // For Ex-Bus-Bar or no selection, show all
    return voltageList;
  };

  const handlevoltageLevel = useCallback(async () => {
    let res = await getAllVoltage(token);
    if (res?.data?.code === 200) {
      res.data.data = res.data.data.map((item) => {
        const { level, ...rest } = item;
        return {
          ...rest,
          name: level,
        };
      });
      setVoltageList(res?.data?.data);
    }
  }, [token]);

  const handleRegion = useCallback(async () => {
    let res = await getAllRegion(token);
    if (res?.data?.code === 200) {
      setRegionList(res?.data?.data);
    }
  }, [token]);

  const fetchData = useCallback(() => {
    handlevoltageLevel();
    handleRegion();
    handleTraderList();
  }, [handleRegion, handlevoltageLevel]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleTraderList = async () => {
    // let res = await getTraderListById(token, user?.userDetails?.company?.id);
    // setTraderList(res?.data?.data);
  };

  // Utility: Find nearest start date/time
  const getNearestStartDateTime = useCallback(() => {
    const validReqs = requirements.filter((r) => r.startDate && r.startTime);
    if (validReqs.length === 0) return null;
    const reqsWithDate = validReqs.map((r) => {
      const dateObj =
        r.startDate instanceof Date
          ? new Date(r.startDate)
          : new Date(r.startDate);
      const [hr, min] = r.startTime.split(":").map(Number);
      dateObj.setHours(hr || 0, min || 0, 0, 0);
      return { ...r, dateTime: dateObj };
    });
    reqsWithDate.sort((a, b) => a.dateTime - b.dateTime);
    return reqsWithDate[0];
  }, [requirements]);

  // Utility: Max expiry = nearest start - 1 hours
  const getListingExpiryMaxDateTime = () => {
    const nearest = getNearestStartDateTime();
    if (!nearest || !nearest.startDate || !nearest.startTime) return null;
    const dateObj =
      nearest.startDate instanceof Date
        ? new Date(nearest.startDate)
        : new Date(nearest.startDate);
    const [hr, min] = nearest.startTime.split(":").map(Number);
    dateObj.setHours(hr || 0, min || 0, 0, 0);
    dateObj.setHours(dateObj.getHours() - 1);
    return dateObj;
  };

  // Handlers
  const handleAddRequirement = () => {
    const energyRateTypeToUse =
      requirements.length > 0 && requirements[0]?.energyRateType
        ? requirements[0].energyRateType
        : { id: 1, name: "DAM+" };
    let newReq = {
      startDate: null,
      startTime: "",
      endDate: null,
      endTime: "",
      energyRate: "",
      quantity: "",
      rtc: false,
      energyRateType: energyRateTypeToUse, // Use consistent energy rate type
    };

    if (reqStage === "intraday") {
      const today = new Date();
      newReq = {
        ...newReq,
        startDate: today,
        endDate: today,
        startTime: "00:00",
        endTime: "24:00",
      };
    } else if (reqStage === "nextday") {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      newReq = {
        ...newReq,
        startDate: tomorrow,
        endDate: tomorrow,
        startTime: "00:00",
        endTime: "24:00",
      };
    } else if (reqStage === "upto_7") {
      newReq = {
        ...newReq,
        startDate: null,
        endDate: null,
        startTime: "",
        endTime: "",
      };
    }
    setRequirements([...requirements, newReq]);
  };

  const handleRemoveRequirement = (index) => {
    setRequirements(requirements.filter((_, i) => i !== index));
  };

  const validateEnergyRateTypeConsistency = () => {
    if (requirements.length <= 1) return true;

    const energyRateTypes = requirements
      .map((req) => req.energyRateType?.name)
      .filter(Boolean);

    if (energyRateTypes.length === 0) return true;

    // Check if there's a mix of Fixed with DAM+/DAM-
    const hasFixed = energyRateTypes.some((type) => type === "Fixed");
    const hasDAM = energyRateTypes.some(
      (type) => type === "DAM+" || type === "DAM-",
    );

    // If both Fixed and DAM types exist, it's invalid
    if (hasFixed && hasDAM) {
      return false;
    }

    return true;
  };

  const handleRequirementChange = (index, field, value) => {
    if (field === "energyRateType") {
      const otherRequirements = requirements.filter((_, i) => i !== index);

      const hasOtherFixed = otherRequirements.some(
        (req) => req.energyRateType?.name === "Fixed",
      );
      const hasOtherDAM = otherRequirements.some(
        (req) =>
          req.energyRateType?.name === "DAM+" ||
          req.energyRateType?.name === "DAM-",
      );

      const isCurrentFixed = value.name === "Fixed";
      const isCurrentDAM = value.name === "DAM+" || value.name === "DAM-";

      // Check if switching between Fixed and DAM types
      if ((isCurrentFixed && hasOtherDAM) || (isCurrentDAM && hasOtherFixed)) {
        // Clear all energy rates and update all requirements to the new type
        setRequirements(
          requirements.map((req) => ({
            ...req,
            energyRateType: value,
            energyRate: "",
          })),
        );

        return;
      }

      setRequirements(
        requirements.map((req, i) =>
          i === index ? { ...req, energyRateType: value, energyRate: "" } : req,
        ),
      );
      return;
    }

    setRequirements(
      requirements.map((req, i) => {
        if (i === index) {
          const updated = { ...req, [field]: value };

          // RTC Logic
          if (
            reqStage !== "intraday" &&
            (field === "startTime" || field === "endTime")
          ) {
            const checkStartTime =
              field === "startTime" ? value : req.startTime;
            const checkEndTime = field === "endTime" ? value : req.endTime;

            if (
              checkStartTime === "00:00" &&
              (checkEndTime === "24:00" || checkEndTime === "23:59")
            ) {
              updated.rtc = true;
            } else {
              updated.rtc = false;
            }
          }
          return updated;
        }
        return req;
      }),
    );
  };
  const handleVoltageChange = (value) => {
    setVoltage(value);
  };

  const handleInitialMarginChange = (value) => {
    setInitialMargin(value);
  };
  const handleEMDChange = (value) => {
    setEmd(value);
  };

  const handlePaymentSecurityChange = (value) => {
    setPaymentSecurity(value);
  };

  const handleRegionChange = (value) => {
    setRegion(value);
  };

  const handleCommentChange = (value) => {
    setComment(value);
  };

  const handleEnergyTypeChange = (value) => {
    setEnergyType(value);
    if (value.type === "Any") {
      // Set both to Any
      // setEnergyReq(energyReqList.find((req) => req.name === "Any"));
    } else if (value.genType === "RENEWABLE") {
      setEnergyReq(energyReqList.find((req) => req.value === "RENEWABLE"));
    } else if (value.genType === "NON_RENEWABLE") {
      setEnergyReq(energyReqList.find((req) => req.value === "NON_RENEWABLE"));
    }
  };

  const handleEnergyReqChange = (value) => {
    setEnergyReq(value);
    if (value.name === "Any") {
      // Set both to Any
      setEnergyType({ id: 16, genType: "RENEWABLE", type: "Any" });
    } else {
      // Clear Energy Type when switching category
      setEnergyType({});
    }
  };

  const handleListingExpDateChange = (value) => {
    setListingExpDate(value);
  };

  const handleListingExpTimeChange = (value) => {
    // If value is "24:00", set to "23:59"
    const newValue = value === "24:00" ? "23:59" : value;
    setListingExpTime(newValue);
  };

  const handleSetTermsExpChange = () => {
    let requisitionArray = requirements;
    // 1. Guard clause
    if (!requisitionArray || requisitionArray.length === 0) return null;

    // 2. Helper to parse Date + Time strings into a valid Date object
    const parseDateTime = (dateStr, timeStr) => {
      const date = new Date(dateStr);
      const [hours, minutes] = timeStr.split(":").map(Number);

      // Ensure we operate in UTC to match the 'Z' in startDate
      date.setUTCHours(hours, minutes, 0, 0);
      return date;
    };

    // 3. Find the earliest start time
    const earliestStart = requisitionArray.reduce((min, current) => {
      const currentStart = parseDateTime(current.startDate, current.startTime);
      return !min || currentStart < min ? currentStart : min;
    }, null);

    if (!earliestStart) return null;

    // 4. Subtract 2 hours
    let time = reqStage === "greater_7" ? 48 : 2;
    const expiryDate = new Date(
      earliestStart.getTime() - time * 60 * 60 * 1000,
    );

    // 5. Format to "dd-MMM-yyyy-hh:mm"
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const pad = (num) => num.toString().padStart(2, "0");

    const day = pad(expiryDate.getUTCDate());
    const month = monthNames[expiryDate.getUTCMonth()]; // Map index to "Jan", "Feb"...
    const year = expiryDate.getUTCFullYear();
    const hours = pad(expiryDate.getUTCHours());
    const minutes = pad(expiryDate.getUTCMinutes());

    // Returns format like: "27-Jan-2026-22:00"
    return `${day}-${month}-${year}to${hours}:${minutes}`;
  };

  function handleGeneralTermsConditions(e) {
    setGeneralTermsConditions(e.id);
  }

  const isTemplateValidForStage = (fileName = "", stage) => {
    if (!stage) return true; // skip if stage not chosen
    const norm = fileName.toLowerCase().replace(/[\s_-]+/g, "");
    const allowedByStage = {
      intraday: ["intraday"],
      nextday: ["nextday", "next_day", "nextday"],
      upto_7: ["upto7", "t+7", "next7", "t7", "uptot+7"],
      greater_7: [
        "greaterthan7",
        "morethant+7",
        "morethan7",
        "greater7",
        "t+7plus",
        "custom",
      ],
    };
    const keys = allowedByStage[stage] || [];
    return keys.some((k) => norm.includes(k.replace(/[\s_-]+/g, "")));
  };

  const handleExcelUpload = async (file) => {
    if (!file) return;

    if (!isTemplateValidForStage(file.name, reqStage)) {
      toast.error(
        "Uploaded file does not match the selected product type. Please upload the correct template.",
        toastProperties,
      );
      return;
    }

    const requiredColumns = [
      "Start Date",
      "End Date",
      "Start Time",
      "End Time",
      "Quantum (MW)",
      "Energy Rate (₹/KWh)",
    ];

    const essentialCols = [
      "Start Date",
      "End Date",
      "Start Time",
      "End Time",
      "Quantum (MW)",
      "Energy Rate (₹/KWh)",
    ];

    const parseExcelDate = (val) => {
      if (!val && val !== 0) return null;
      // Excel serial -> ISO
      if (typeof val === "number") {
        const iso = excelDateToISO(val);
        return iso ? new Date(iso) : null;
      }
      // String DD/MM/YYYY or DD-MM-YYYY
      if (typeof val === "string") {
        const t = val.trim();
        const match = /^(\d{2})[\/-](\d{2})[\/-](\d{4})$/.exec(t);
        if (match) {
          const [, d, m, y] = match;
          return new Date(`${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`);
        }
      }
      const d = new Date(val);
      return isValidDateValue(d) ? d : null;
    };

    const normalizeTime = (value) => {
      if (value === undefined || value === null || value === "") return "";

      // ✅ ExcelJS Date object (time stored as UTC)
      if (value instanceof Date && !isNaN(value)) {
        const h = value.getUTCHours();
        const m = value.getUTCMinutes();

        // Handle 24:00 edge case (Excel sometimes stores as next day 00:00)
        if (h === 0 && m === 0 && value.getUTCDate() === 31) {
          return "24:00";
        }

        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      }

      // ✅ Excel time as number (fraction of day)
      if (typeof value === "number") {
        const totalMinutes = Math.round(value * 24 * 60);
        const h = Math.floor(totalMinutes / 60);
        const m = totalMinutes % 60;
        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      }

      // ✅ Already a string
      const t = String(value).trim();
      const match = /^(\d{1,2}):(\d{2})$/.exec(t);
      if (match) {
        const h = Number(match[1]);
        const m = Number(match[2]);
        if (h === 24 && m === 0) return "24:00";
        if (h >= 0 && h <= 23 && m >= 0 && m <= 59) {
          return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
        }
      }

      return "";
    };

    try {
      const buffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer);

      const sheet = workbook.worksheets[0];
      if (!sheet) {
        ErrorMessage("Invalid Excel template");
        return;
      }

      // Locate header row (where second cell is "Start Date")
      let headerRowIdx = null;
      let headers = [];
      sheet.eachRow((row, rowNum) => {
        if (readCell(row.getCell(2)) === "Start Date") {
          headerRowIdx = rowNum;
          headers = row.values
            .slice(1)
            .map((v) => (typeof v === "string" ? v.trim() : v));
        }
      });

      if (!headerRowIdx || headers.length === 0) {
        ErrorMessage("Invalid template: header row not found");
        return;
      }

      // Check required columns exist
      const missing = requiredColumns.filter((col) => !headers.includes(col));
      if (missing.length) {
        toast.error(
          `Missing required columns: ${missing.join(", ")}`,
          toastProperties,
        );
        return;
      }

      // Build row objects
      const ignoredCols = ["Quantum (MWh)", "Requisition"];
      const sheetData = [];
      const startRow = 8;
      const endRow = 19;

      sheet.eachRow((row, rowNum) => {
        if (rowNum < startRow || rowNum > endRow) return; // only rows 8–19

        const obj = {};
        headers.forEach((col, idx) => {
          if (!col || ignoredCols.includes(col)) return;
          const val = readCell(row.getCell(idx + 1));
          obj[col] = typeof val === "string" ? val.trim() : val;
        });

        // Skip rows that are truly empty (after trimming)
        const hasValue = Object.values(obj).some((v) => {
          if (v === 0) return true;
          if (v === null || v === undefined) return false;
          const s = typeof v === "string" ? v.trim() : String(v).trim();
          return s !== "";
        });
        if (!hasValue) return;

        sheetData.push(obj);
      });
      if (!sheetData.length) {
        ErrorMessage("No requisitions found in Excel");
        return;
      }

      const normalizeVoltage = (val) =>
        val
          ?.toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/kv$/, "kv");

      const voltageFromC4 = readCell(sheet.getCell("C4"));
      if (voltageFromC4) {
        const target = normalizeVoltage(voltageFromC4);
        const matchedVoltage = voltageList.find(
          (v) => normalizeVoltage(v?.name) === target,
        );
        setVoltage(matchedVoltage || { id: "", name: voltageFromC4 });
      }

      const normalizeText = (val) => val?.toString().trim().toLowerCase();
      const equalsNormalized = (a, b) => normalizeText(a) === normalizeText(b);

      // B2: Region (only warn for generators; we don't override)
      const regionFromB2 = readCell(sheet.getCell("B2"));
      if (
        activeRole === "GENERATOR" &&
        regionFromB2 &&
        region?.name &&
        !equalsNormalized(regionFromB2, region?.name)
      ) {
        toast.info(
          "Region can't be changed for Generator uploads; using default region.",
          toastProperties,
        );
      }

      // C2: Energy Requirement (Any / RE / Non-RE)
      const energyReqFromC2 = readCell(sheet.getCell("C2"));
      let matchedEnergyReq = null;

      if (energyReqFromC2 && activeRole !== "GENERATOR") {
        const target = normalizeText(energyReqFromC2);
        matchedEnergyReq = energyReqList.find((er) => {
          const n = normalizeText(er?.name);
          const v = normalizeText(er?.value);
          return n === target || (v && v === target);
        });

        if (!matchedEnergyReq) {
          toast.error(
            `Invalid Energy Requirement: "${energyReqFromC2}".`,
            toastProperties,
          );
          return;
        }
      } else if (
        energyReqFromC2 &&
        activeRole === "GENERATOR" &&
        energyReq?.name &&
        !equalsNormalized(regionFromB2, energyReq?.name) &&
        !equalsNormalized(regionFromB2, energyReq?.value)
      ) {
        toast.info(
          "Energy Requirement can't be changed for Generator uploads. Using default value.",
          toastProperties,
        );
        matchedEnergyReq = energyReq;
      }

      // D2: Energy Type (matches energyList by name/type/genType)
      const energyTypeFromD2 = readCell(sheet.getCell("D2"));
      let matchedEnergyType = null;

      if (energyTypeFromD2 && activeRole !== "GENERATOR") {
        const target = normalizeText(energyTypeFromD2);
        matchedEnergyType = energyList.find((et) => {
          const n = normalizeText(et?.name);
          const t = normalizeText(et?.type);
          const g = normalizeText(et?.genType);
          return n === target || t === target || g === target;
        });

        if (!matchedEnergyType) {
          toast.error(
            `Invalid Energy Type: "${energyTypeFromD2}". Please check the template for valid options.`,
            toastProperties,
          );
          return;
        }

        // Validate compatibility between Energy Requirement and Energy Type
        if (matchedEnergyReq && matchedEnergyType) {
          // Skip validation if Energy Requirement is "Any"
          if (matchedEnergyReq.name !== "Any") {
            const energyTypeGenType = matchedEnergyType.genType; // "RENEWABLE" or "NON_RENEWABLE"
            const energyReqValue = matchedEnergyReq.value; // "RENEWABLE" or "NON_RENEWABLE"

            if (energyTypeGenType !== energyReqValue) {
              toast.error(
                `Energy Type "${energyTypeFromD2}" (${energyTypeGenType}) is incompatible with Energy Requirement "${energyReqFromC2}" (${energyReqValue}). Please ensure they match.`,
                toastProperties,
              );
              return;
            }
          }
        }

        setEnergyType(matchedEnergyType);
        if (matchedEnergyReq) {
          setEnergyReq(matchedEnergyReq);
        }
      } else if (
        energyTypeFromD2 &&
        activeRole === "GENERATOR" &&
        energyType &&
        !(
          equalsNormalized(energyTypeFromD2, energyType?.name) ||
          equalsNormalized(energyTypeFromD2, energyType?.type) ||
          equalsNormalized(energyTypeFromD2, energyType?.genType)
        )
      ) {
        toast.info(
          "Energy Type can't be changed for Generator upload. Using default value.",
          toastProperties,
        );
      }

      // E2: Point of Drawal/Injection (ISTS / STU / Ex-Bus-Bar)
      const podFromE2 = readCell(sheet.getCell("E2"));
      if (podFromE2) {
        const target = normalizeText(podFromE2);
        const matchedPod = injDrawl.find(
          (p) => normalizeText(p?.name) === target,
        );
        setInjectDrawl(matchedPod || { id: "", name: podFromE2 });
      }

      // F2: Delivery Type (Intrastate / InterState)
      const deliveryFromF2 = readCell(sheet.getCell("F2"));
      if (deliveryFromF2) {
        const target = deliveryFromF2;

        // const matchedDelivery = deliveryTypeList.find(
        //   (d) => normalizeText(d?.name) === target
        // );

        let aa = {};

        if (target === "Intrastate") {
          aa = { id: 1, name: "Intrastate", value: false };
        } else if (target === "Interstate") {
          aa = { id: 2, name: "InterState", value: true };
        }
        setDeliveryType(aa || { id: "", name: target });
      }

      // if (reqStage === "greater_7") {
      //   const toNumberString = (val) => {
      //     const num = Number(val);
      //     return Number.isFinite(num) ? String(num) : "";
      //   };

      //   const emdFromE4 = readCell(sheet.getCell("E4"));
      //   const imFromF4 = readCell(sheet.getCell("F4"));
      //   const psFromG4 = readCell(sheet.getCell("G4"));

      //   if (emdFromE4) setEmd(toNumberString(emdFromE4));
      //   if (imFromF4) setInitialMargin(toNumberString(imFromF4));
      //   if (psFromG4) setPaymentSecurity(toNumberString(psFromG4));
      // }

      const normalizeEnergyRateType = (val) => {
        if (!val && val !== 0) return undefined;
        const t = val.toString().trim().toUpperCase();
        if (t === "FIXED") return "FIXED";
        if (t === "DAM+" || t === "DAM PLUS" || t === "DAM_PLUS")
          return "DAM_PLUS";
        if (t === "DAM-" || t === "DAM MINUS" || t === "DAM_MINUS")
          return "DAM_MINUS";
        return undefined;
      };

      const energyRateTypeHint = normalizeEnergyRateType(
        readCell(sheet.getCell("D4")),
      );

      if (energyRateTypeHint) {
        setRateType(energyRateTypeHint === "FIXED" ? "number" : "string");
      }

      const commentFromC24 = readCell(sheet.getCell("C24"));
      if (commentFromC24) {
        setComment(commentFromC24.toString().trim());
      }

      for (let i = 0; i < sheetData.length; i++) {
        const row = sheetData[i];
        for (const col of essentialCols) {
          const val = row[col];

          // Skip empty values entirely
          if (val === undefined || val === null || String(val).trim() === "") {
            continue;
          }

          // If a date string is present, ensure it is valid format
          if (col.includes("Date") && typeof val === "string") {
            const t = val.trim();
            if (!/^\d{2}[\/-]\d{2}[\/-]\d{4}$/.test(t) && isNaN(Number(t))) {
              toast.error(
                `Row ${
                  i + 2
                } has invalid date format for "${col}". Use DD/MM/YYYY or DD-MM-YYYY.`,
                toastProperties,
              );
              return;
            }
          }
        }
      }

      // Map to requirements state
      const newRequirements = sheetData.map((row) => {
        const startDate = parseExcelDate(row["Start Date"]);
        const endDate = parseExcelDate(row["End Date"]);
        const startTime = normalizeTime(row["Start Time"]);
        const endTime = normalizeTime(row["End Time"]);

        const raw = row["Energy Rate (₹/KWh)"]?.toString().trim() || "";

        const energyRateType =
          energyRateTypeHint === "FIXED"
            ? { id: 3, name: "Fixed" }
            : energyRateTypeHint === "DAM_PLUS"
              ? { id: 1, name: "DAM+" }
              : energyRateTypeHint === "DAM_MINUS"
                ? { id: 2, name: "DAM-" }
                : {};

        // Add DAM+/DAM- prefix if needed
        let energyRate = raw;
        if (energyRateType === "DAM_PLUS") {
          const cleaned = raw.replace(/^DAM\+?/i, "").replace(/^\+/, "");
          energyRate = `DAM+${cleaned}`;
        } else if (energyRateType === "DAM_MINUS") {
          const cleaned = raw.replace(/^DAM-?/i, "").replace(/^-/, "");
          energyRate = `DAM-${cleaned}`;
        }

        return {
          startDate: isValidDateValue(startDate) ? startDate : null,
          endDate: isValidDateValue(endDate) ? endDate : null,
          startTime,
          endTime,
          quantity: row["Quantum (MW)"]?.toString() || "",
          energyRate,
          energyRateType,
          rtc:
            startTime === "00:00" &&
            (endTime === "24:00" || endTime === "23:59"),
        };
      });

      // Keep only rows that have at least one non-empty field
      const filteredRequirements = newRequirements.filter(
        (r) =>
          r.startDate ||
          r.endDate ||
          r.startTime ||
          r.endTime ||
          (r.quantity && String(r.quantity).trim() !== "") ||
          (r.energyRate && String(r.energyRate).trim() !== ""),
      );

      if (!filteredRequirements.length) {
        ErrorMessage("No requisitions found in Excel");
        return;
      }

      // Log parsed JSON
      console.log(
        "Parsed Excel requirements:",
        JSON.stringify(filteredRequirements, null, 2),
      );

      setRequirements(filteredRequirements);
      setErrors({});
      toast.success("Excel uploaded successfully", toastProperties);
    } catch (err) {
      console.error(err);
      ErrorMessage("Failed to read Excel file");
    }
  };

  async function handleDownloadExcel() {
    try {
      let response;
      // Format date as DD-MM-YYYY
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      const dateStr = `${dd}-${mm}-${yyyy}`;

      let filename = `Listing_Bilateral_Template_${dateStr}.xlsx`;
      if (activeRole === "CONSUMER") {
        if (reqStage === "intraday") {
          response = await fetch(IntradayListingConsumer);
          filename = `Listing_Bilateral_Intraday_${dateStr}.xlsx`;
        }
        if (reqStage === "nextday") {
          response = await fetch(NextDayListingConsumer);
          filename = `Listing_Bilateral_NextDay_${dateStr}.xlsx`;
        }
        if (reqStage === "upto_7") {
          response = await fetch(Next7DayListingConsumer);
          filename = `Listing_Bilateral_Next7Days_${dateStr}.xlsx`;
        }
        if (reqStage === "greater_7") {
          response = await fetch(GreaterThan7DaysListingConsumer);
          filename = `Listing_Bilateral_Custom_${dateStr}.xlsx`;
        }
      }

      if (activeRole === "GENERATOR") {
        if (reqStage === "intraday") {
          response = await fetch(IntradayListingGenerator);
          filename = `Listing_Bilateral_Intraday_${dateStr}.xlsx`;
        }
        if (reqStage === "nextday") {
          response = await fetch(NextDayListingGenerator);
          filename = `Listing_Bilateral_NextDay_${dateStr}.xlsx`;
        }
        if (reqStage === "upto_7") {
          response = await fetch(Next7DayListingGenerator);
          filename = `Listing_Bilateral_Next7Days_${dateStr}.xlsx`;
        }
        if (reqStage === "greater_7") {
          response = await fetch(GreaterThan7DaysListingGenerator);
          filename = `Listing_Bilateral_Custom_${dateStr}.xlsx`;
        }
      }

      if (!response.ok) {
        throw new Error("Failed to fetch template");
      }

      const blob = await response.blob();
      saveAs(blob, filename);
    } catch (error) {
      console.error(error);
      toast.error("Error downloading template", toastProperties);
    }
  }

  useEffect(() => {
    // Auto-populate Listing Expiry Date and Time when requirements change
    if (requirements.length > 0 && !editId) {
      const nearest = getNearestStartDateTime();
      if (nearest && nearest.startDate && nearest.startTime) {
        const startDateTime = new Date(nearest.startDate);
        const [hr, min] = nearest.startTime.split(":").map(Number);
        startDateTime.setHours(hr || 0, min || 0, 0, 0);
        // Set listing expiry to 3 hours before start time
        const expiryDateTime = new Date(startDateTime);

        expiryDateTime.setHours(
          expiryDateTime.getHours() - (reqStage === "greater_7" ? 96 : 3),
        );
        // Set terms expiry to 2 hours before start time
        const termsExpiryDateTime = new Date(startDateTime);
        termsExpiryDateTime.setHours(termsExpiryDateTime.getHours() - 2);

        // Only update if the calculated expiry is in the future
        const now = new Date();

        if (expiryDateTime > now) {
          setListingExpDate(expiryDateTime);
          setListingExpTime(
            `${expiryDateTime
              .getHours()
              .toString()
              .padStart(2, "0")}:${expiryDateTime
              .getMinutes()
              .toString()
              .padStart(2, "0")}`,
          );

          // Also set terms expiry to the same value
          setTermsExpDate(termsExpiryDateTime);
          setTermsExpTime(
            `${termsExpiryDateTime
              .getHours()
              .toString()
              .padStart(2, "0")}:${termsExpiryDateTime
              .getMinutes()
              .toString()
              .padStart(2, "0")}`,
          );
        }
      }
    }
  }, [requirements, editId, reqStage, getNearestStartDateTime]);

  // Add this useEffect to auto-set RTC when times are 00:00 and 24:00
  useEffect(() => {
    setRequirements((prev) => {
      let hasChanges = false;
      const updated = prev.map((req) => {
        // Auto-set RTC if times are 00:00 and 24:00 (except for intraday)
        if (
          reqStage !== "intraday" &&
          req.startTime === "00:00" &&
          (req.endTime === "24:00" || req.endTime === "23:59") &&
          !req.rtc // Only update if rtc is not already true
        ) {
          hasChanges = true;
          return { ...req, rtc: true };
        }
        // Reset RTC if times are not 00:00 and 24:00 but rtc is true
        if (
          req.rtc &&
          (req.startTime !== "00:00" ||
            (req.endTime !== "24:00" && req.endTime !== "23:59"))
        ) {
          hasChanges = true;
          return { ...req, rtc: false };
        }
        return req;
      });

      // Only update state if there are actual changes
      return hasChanges ? updated : prev;
    });
  }, [reqStage]); // Remove 'requirements' from dependencies

  // Add a new useEffect to trigger validation on field changes
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      validateFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    requirements,
    energyReq,
    energyType,
    voltage,
    injectDrawl,
    deliveryType,
    region,
    initialMargin,
    emd,
    paymentSecurity,
    listingExpDate,
    listingExpTime,
    termsExpDate,
    termsExpTime,
  ]);

  const isValidEnergyRate = (value) => {
    if (value === undefined || value === null || value === "") return false;
    if (!isNaN(Number(value))) return true;
  };

  // Validation
  const validateFields = () => {
    const newErrors = {};
    const maxQuantity = getMaxQuantity();

    if (!validateEnergyRateTypeConsistency()) {
      requirements.forEach((_, idx) => {
        newErrors[`energyRateType_${idx}`] =
          "Energy Rate Type must be either all DAM+/DAM- or all Fixed";
      });
    }

    // Define date boundaries based on reqStage
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const upto7 = new Date(today);
    upto7.setDate(today.getDate() + 6);
    const greater7EndMin = new Date(today);
    greater7EndMin.setDate(today.getDate() + 7);
    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(today.getDate() + 2);
    const next7EndMax = new Date(today);
    next7EndMax.setDate(today.getDate() + 6);

    requirements.forEach((req, idx) => {
      if (!req.energyRateType || !req.energyRateType.id) {
        newErrors[`energyRateType_${idx}`] = "Energy Rate Type is required";
      }
      if (!req.startDate) {
        newErrors[`startDate_${idx}`] = "Start Date is required";
      } else {
        const startDateObj =
          req.startDate instanceof Date
            ? new Date(req.startDate)
            : new Date(req.startDate);
        startDateObj.setHours(0, 0, 0, 0);

        const greaterthan7 = new Date(today);
        greaterthan7.setDate(today.getDate() + 4);

        // Validate start date based on reqStage
        if (reqStage === "intraday") {
          if (startDateObj.getTime() !== today.getTime()) {
            newErrors[`startDate_${idx}`] =
              "Start Date must be today for Intraday";
          }
        } else if (reqStage === "nextday") {
          if (startDateObj.getTime() !== tomorrow.getTime()) {
            newErrors[`startDate_${idx}`] =
              "Start Date must be tomorrow for Next Day";
          }
        } else if (reqStage === "upto_7") {
          if (startDateObj < today || startDateObj > upto7) {
            newErrors[`startDate_${idx}`] =
              "Start Date must be within next 7 days";
          }
        } else if (reqStage === "greater_7") {
          if (startDateObj < greaterthan7) {
            newErrors[`startDate_${idx}`] =
              "Start Date must be at least 4 days from today for Custom";
          }
        } else if (startDateObj < today) {
          newErrors[`startDate_${idx}`] = "Start Date must be today or later";
        }
      }

      if (!req.endDate) {
        newErrors[`endDate_${idx}`] = "End Date is required";
      } else {
        const endDateObj =
          req.endDate instanceof Date
            ? new Date(req.endDate)
            : new Date(req.endDate);
        endDateObj.setHours(0, 0, 0, 0);

        // Validate end date based on reqStage
        if (reqStage === "intraday") {
          if (endDateObj.getTime() !== today.getTime()) {
            newErrors[`endDate_${idx}`] = "End Date must be today for Intraday";
          }
        } else if (reqStage === "nextday") {
          if (endDateObj.getTime() !== tomorrow.getTime()) {
            newErrors[`endDate_${idx}`] =
              "End Date must be tomorrow for Next Day";
          }
        } else if (reqStage === "upto_7") {
          if (endDateObj < dayAfterTomorrow || endDateObj > next7EndMax) {
            newErrors[`endDate_${idx}`] =
              "End Date must be between day after tomorrow and 6 days from today";
          }
        } else if (reqStage === "greater_7") {
          // End date must be at least 7 days from today
          // if (endDateObj < greater7EndMin) {
          //   newErrors[`endDate_${idx}`] =
          //     "End Date must be at least 7 days from today for Custom";
          // }
          // // Additionally, validate that the duration is more than 7 days
          // if (req.startDate) {
          //   const startDateObj =
          //     req.startDate instanceof Date
          //       ? new Date(req.startDate)
          //       : new Date(req.startDate);
          //   startDateObj.setHours(0, 0, 0, 0);
          //   const durationDays =
          //     Math.floor((endDateObj - startDateObj) / (1000 * 60 * 60 * 24)) +
          //     1;
          //   if (durationDays <= 7) {
          //     newErrors[`endDate_${idx}`] =
          //       "Duration must be Custom for this listing type";
          //   }
          // }
        }

        if (!initialMargin) {
          newErrors.initialMargin = "Initial Margin is required";
        } else if (
          isNaN(Number(initialMargin)) ||
          Number(initialMargin) < 100 ||
          Number(initialMargin) > 200
        ) {
          newErrors.initialMargin =
            "Initial Margin must be between 100 and 200";
        }

        // Check if end date is before start date
        if (req.startDate) {
          const startDateObj =
            req.startDate instanceof Date
              ? new Date(req.startDate)
              : new Date(req.startDate);
          startDateObj.setHours(0, 0, 0, 0);

          if (endDateObj < startDateObj) {
            newErrors[`endDate_${idx}`] =
              "End Date must be after or same as Start Date";
          }
        }
      }

      if (!req.startTime) {
        newErrors[`startTime_${idx}`] = "Start Time is required";
      }

      if (!req.endTime) {
        newErrors[`endTime_${idx}`] = "End Time is required";
      }

      if (!req.quantity) {
        newErrors[`quantity_${idx}`] = "Quantity is required";
      } else if (maxQuantity && Number(req.quantity) > Number(maxQuantity)) {
        newErrors[`quantity_${idx}`] =
          `Quantity cannot exceed ${maxQuantity} MW`;
      }

      if (!req.startTime) {
        newErrors[`startTime_${idx}`] = "Start Time is required";
      } else if (!isValidTime(req.startTime)) {
        newErrors[`startTime_${idx}`] = "Time cannot exceed 24:00";
      }

      if (!req.endTime) {
        newErrors[`endTime_${idx}`] = "End Time is required";
      } else if (!isValidTime(req.endTime)) {
        newErrors[`endTime_${idx}`] = "Time cannot exceed 24:00";
      }

      if (!req.energyRate) {
        newErrors[`energyRate_${idx}`] = "Energy Rate is required";
      } else if (!isValidEnergyRate(req.energyRate)) {
        newErrors[`energyRate_${idx}`] = "Enter a valid number";
      } else if (
        !isNaN(req.energyRate) &&
        Number(req.energyRate) <= 0 &&
        req.energyRateType?.name === "Fixed" // Check per requirement
      ) {
        newErrors[`energyRate_${idx}`] = "Energy Rate must be greater than 0";
      }

      // Start time must be at least 3 hours from now
      if (req.startDate && req.startTime) {
        const now = new Date();
        const minAllowed = new Date(now.getTime() + 3 * 60 * 60 * 1000);
        const startDateObj =
          req.startDate instanceof Date
            ? new Date(req.startDate)
            : new Date(req.startDate);
        const [hr, min] = req.startTime.split(":").map(Number);
        startDateObj.setHours(hr || 0, min || 0, 0, 0);
        if (startDateObj < minAllowed) {
          newErrors[`startTime_${idx}`] =
            "Start Time should be at least 3 hours from current time";
        }
      }

      // End time must be greater than start time
      if (req.startDate && req.startTime && req.endDate && req.endTime) {
        const startDateObj =
          req.startDate instanceof Date
            ? new Date(req.startDate)
            : new Date(req.startDate);
        const endDateObj =
          req.endDate instanceof Date
            ? new Date(req.endDate)
            : new Date(req.endDate);
        const [startHr, startMin] = req.startTime.split(":").map(Number);
        const [endHr, endMin] = req.endTime.split(":").map(Number);

        if (endHr < startHr || (endHr === startHr && endMin <= startMin)) {
          newErrors[`endTime_${idx}`] =
            "End Time must be greater than Start Time";
        }
      }

      // Check for overlapping date ranges and time conflicts
      if (req.startDate && req.endDate && req.startTime && req.endTime) {
        // Helper to check if two date ranges overlap
        const dateRangesOverlap = (start1, end1, start2, end2) => {
          const s1 = new Date(start1);
          const e1 = new Date(end1);
          const s2 = new Date(start2);
          const e2 = new Date(end2);
          s1.setHours(0, 0, 0, 0);
          e1.setHours(0, 0, 0, 0);
          s2.setHours(0, 0, 0, 0);
          e2.setHours(0, 0, 0, 0);
          return s1 <= e2 && e1 >= s2;
        };

        // Helper to check if two time ranges overlap
        const timeRangesOverlap = (start1, end1, start2, end2) => {
          const [h1, m1] = start1.split(":").map(Number);
          const [h2, m2] = end1.split(":").map(Number);
          const [h3, m3] = start2.split(":").map(Number);
          const [h4, m4] = end2.split(":").map(Number);

          const t1Start = h1 * 60 + m1;
          let t1End = h2 * 60 + m2;
          const t2Start = h3 * 60 + m3;
          let t2End = h4 * 60 + m4;

          // Handle 24:00 as 1440 minutes (end of day)
          if (h2 === 24) t1End = 1440;
          if (h4 === 24) t2End = 1440;
          if (h2 === 23 && m2 === 59) t1End = 1439;
          if (h4 === 23 && m4 === 59) t2End = 1439;

          // Two time ranges overlap if: start1 < end2 AND end1 > start2
          return t1Start < t2End && t1End > t2Start;
        };

        // Check against all other requirements
        for (let otherIdx = 0; otherIdx < requirements.length; otherIdx++) {
          if (otherIdx === idx) continue; // Skip self-comparison

          const otherReq = requirements[otherIdx];

          if (
            otherReq.startDate &&
            otherReq.endDate &&
            otherReq.startTime &&
            otherReq.endTime
          ) {
            // First check if date ranges overlap
            const datesOverlap = dateRangesOverlap(
              req.startDate,
              req.endDate,
              otherReq.startDate,
              otherReq.endDate,
            );

            // If dates overlap, check if times also overlap
            // if (datesOverlap) {
            //   const timesOverlap = timeRangesOverlap(
            //     req.startTime,
            //     req.endTime,
            //     otherReq.startTime,
            //     otherReq.endTime
            //   );

            //   if (timesOverlap) {
            //     const formatDateTime = (date) => {
            //       const d = date instanceof Date ? date : new Date(date);
            //       const day = d.getDate().toString().padStart(2, "0");
            //       const month = (d.getMonth() + 1).toString().padStart(2, "0");
            //       const year = d.getFullYear();
            //       return `${day}/${month}/${year}`;
            //     };

            //     const overlapMsg = `Time overlaps with Req ${
            //       otherIdx + 1
            //     } (${formatDateTime(otherReq.startDate)} - ${formatDateTime(
            //       otherReq.endDate
            //     )}, ${otherReq.startTime} - ${otherReq.endTime})`;

            //     newErrors[`startTime_${idx}`] = overlapMsg;
            //     newErrors[`endTime_${idx}`] = overlapMsg;

            //     // Mark the other requirement as well
            //     newErrors[`startTime_${otherIdx}`] = `Time overlaps with Req ${
            //       idx + 1
            //     } (${formatDateTime(req.startDate)} - ${formatDateTime(
            //       req.endDate
            //     )}, ${req.startTime} - ${req.endTime})`;
            //     newErrors[`endTime_${otherIdx}`] = `Time overlaps with Req ${
            //       idx + 1
            //     }`;

            //     break; // Found an overlap, no need to check further
            //   }
            // }
          }
        }
      }
    });

    if (listingExpTime && !isValidTime(listingExpTime)) {
      newErrors.listingExpTime = "Time cannot exceed 24:00";
    }

    if (termsExpTime && !isValidTime(termsExpTime)) {
      newErrors.termsExpTime = "Time cannot exceed 24:00";
    }

    if (!energyReq?.id)
      newErrors.energyReq = "Energy Type & Requirement is required";
    if (!energyType?.id)
      newErrors.energyType = "Energy Type & Requirement is required";
    if (!voltage?.id) newErrors.voltage = "Voltage Level is required";
    if (!injectDrawl?.id)
      newErrors.injectDrawl = "Point of Drawal/Injection is required";
    if (!deliveryType?.id) newErrors.deliveryType = "Delivery Type is required";
    if (!region?.id) newErrors.region = "Region is required";
    if (!initialMargin) {
      newErrors.initialMargin = "Initial Margin is required";
    } else if (
      isNaN(Number(initialMargin)) ||
      Number(initialMargin) < 0 ||
      Number(initialMargin) > 200
    ) {
      newErrors.initialMargin = "Initial Margin must be between 0 and 200";
    }
    // if (!emd) newErrors.emd = "EMD is required";
    if (!paymentSecurity)
      newErrors.paymentSecurity = "Payment Security is required";
    if (!listingExpDate)
      newErrors.listingExpDate = "Listing Expiry Date is required";
    if (!listingExpTime)
      newErrors.listingExpTime = "Listing Expiry Time is required";
    if (!termsExpDate) newErrors.termsExpDate = "Terms Expiry Date is required";
    if (!termsExpTime) newErrors.termsExpTime = "Terms Expiry Time is required";

    // New: calculate maximum duration (in days) across all requirements
    let maxRequirementDays = 0;
    requirements.forEach((req, idx) => {
      if (req.startDate && req.endDate) {
        const s =
          req.startDate instanceof Date
            ? new Date(req.startDate)
            : new Date(req.startDate);
        const e =
          req.endDate instanceof Date
            ? new Date(req.endDate)
            : new Date(req.endDate);
        // normalize to midnight to count full days
        s.setHours(0, 0, 0, 0);
        e.setHours(0, 0, 0, 0);
        const diffDays = Math.floor((e - s) / (1000 * 60 * 60 * 24)) + 1; // inclusive

        if (!isNaN(diffDays) && diffDays > maxRequirementDays) {
          maxRequirementDays = diffDays;
        }
      }
    });

    // Expiry checks
    const nearest = getNearestStartDateTime();
    let nearestDateTime = null;
    if (nearest && nearest.startDate && nearest.startTime) {
      nearestDateTime =
        nearest.startDate instanceof Date
          ? new Date(nearest.startDate)
          : new Date(nearest.startDate);
      const [hr, min] = nearest.startTime.split(":").map(Number);
      nearestDateTime.setHours(hr || 0, min || 0, 0, 0);
    }
    let maxExpiryDateTime = null;
    if (nearestDateTime) {
      maxExpiryDateTime = new Date(nearestDateTime);
      maxExpiryDateTime.setHours(
        maxExpiryDateTime.getHours() - (reqStage === "greater_7" ? 96 : 2),
      );
    }
    const listingExpiryDT = combineDateTime(listingExpDate, listingExpTime);
    const termsExpiryDT = combineDateTime(termsExpDate, termsExpTime);

    if (
      listingExpiryDT &&
      maxExpiryDateTime &&
      listingExpiryDT > maxExpiryDateTime
    ) {
      newErrors.listingExpDate = `Listing Expiry must be at least  ${reqStage === "greater_7" ? "4 days" : "3 hours"} before the earliest start time`;
      newErrors.listingExpTime = `Listing Expiry must be at least  ${reqStage === "greater_7" ? "4 days" : "3 hours"} before the earliest start time`;
    }
    // if (
    //   termsExpiryDT &&
    //   maxExpiryDateTime &&
    //   termsExpiryDT > maxExpiryDateTime
    // ) {
    //   newErrors.termsExpDate =
    //     "Terms Expiry must be at least 2 hours before the earliest start time";
    //   newErrors.termsExpTime =
    //     "Terms Expiry must be at least 2 hours before the earliest start time";
    // }

    // if (termsExpiryDT && listingExpiryDT && termsExpiryDT < listingExpiryDT) {
    //   newErrors.termsExpDate = "Terms Expiry cannot be before Listing Expiry";
    //   newErrors.termsExpTime = "Terms Expiry cannot be before Listing Expiry";
    // }

    // Add after other expiry checks
    const now = new Date();
    if (listingExpiryDT && listingExpiryDT < now) {
      newErrors.listingExpTime =
        "Listing Expiry Time must be greater than current time";
      newErrors.listingExpDate =
        "Listing Expiry Time must be greater than current time";
    }
    if (termsExpiryDT && termsExpiryDT < now) {
      newErrors.termsExpTime =
        "Terms Expiry Time must be greater than current time";
      newErrors.termsExpDate =
        "Terms Expiry Time must be greater than current time";
    }

    // validate paymentSecurity doesn't exceed max requirement days (if any requirement days present)
    // if (paymentSecurity && maxRequirementDays > 0) {
    //   const psNumber = Number(paymentSecurity);
    //   if (!isNaN(psNumber) && psNumber > maxRequirementDays) {
    //     newErrors.paymentSecurity = `Payment Security cannot exceed the maximum requirement duration of ${maxRequirementDays} day(s)`;
    //   }
    // }

    console.log("Validation Errors:", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submission
  const handleContinue = () => {
    if (!validateFields()) return;
    if (!editId && !acceptSystemTerms) {
      toast.error(
        "Please accept System Terms and Conditions.",
        toastProperties,
      );
      return;
    }
    setTermsError("");
    handleFormSubmit();
  };

  const handleFormSubmit = () => {
    // Safety net: re-validate before building payload
    if (!validateFields()) return;

    const normalizedRequirements = requirements?.map((ele) => ({
      ...ele,
      endTime: ele?.endTime === "24:00" ? "23:59" : ele?.endTime,
    }));

    const listingTypeMap = {
      intraday: "INTRA_DAY",
      nextday: "NEXT_DAY",
      upto_7: "UPTO_SEVEN_DAYS",
      greater_7: "GREATER_THAN_SEVEN_DAYS",
    };

    let termsDate = handleSetTermsExpChange()?.split("to")?.[0];
    let termsTime = handleSetTermsExpChange()?.split("to")?.[1];

    const payload = {
      id: null,
      name: null,
      priceDiscoveryType: "BILATERAL",
      consumerId: user?.userDetails?.id,
      energySourceType: energyReq?.name,
      energyFuelType: energyType?.type,
      listingType: listingTypeMap[reqStage],
      isIntraDay:
        reqStage === "intraday" || reqStage === "nextday" ? true : false,
      slots: normalizedRequirements?.map((ele) => ({
        dateStartAt: formatDateElement(ele?.startDate),
        dateEndAt: formatDateElement(ele?.endDate),
        slotStartAt: ele?.startTime,
        slotEndAt: ele?.endTime,
        landingCost:
          activeRole === "CONSUMER"
            ? isNaN(ele?.energyRate)
              ? ele?.energyRate?.split("+")?.[1]
                ? Number(ele?.energyRate?.split("+")?.[1])
                : Number(ele?.energyRate?.split("-")?.[1])
              : Number(ele?.energyRate)
            : null,
        purchaseEnergy:
          activeRole === "CONSUMER" ? Number(ele?.quantity) : null,
        sellingCost:
          activeRole === "GENERATOR"
            ? isNaN(ele?.energyRate)
              ? ele?.energyRate?.split("DAM+")?.[1]
                ? ele?.energyRate?.split("DAM+")?.[1]
                : ele?.energyRate?.split("DAM-")?.[1]
              : Number(ele?.energyRate)
            : null,
        sellEnergy: activeRole === "GENERATOR" ? Number(ele?.quantity) : null,
        energyRateStr:
          ele?.energyRateType?.name === "Fixed"
            ? null
            : ele?.energyRateType?.name === "DAM+"
              ? `DAM+${ele?.energyRate}`
              : ele?.energyRateType?.name === "DAM-"
                ? `DAM-${ele?.energyRate}`
                : null,
        energyRateType:
          ele?.energyRateType?.name === "Fixed"
            ? "FIXED"
            : ele?.energyRateType?.name === "DAM+"
              ? "DAM_PLUS"
              : ele?.energyRateType?.name === "DAM-"
                ? "DAM_MINUS"
                : null,
      })),
      region: region?.name,
      bidEndAt: `${formatDateElement(listingExpDate)} ${listingExpTime}`,
      voltageLevel: voltage?.name,
      isInterstate: deliveryType?.value ? true : false,
      traderAssigned: isTrader?.roles?.includes("TRADER")
        ? isTrader?.user?.user?.userId
        : 0,
      isBilateral: true,
      initialMargin: Number(initialMargin),
      emd: Number(emd || 0),
      paymentSecurity: Number(paymentSecurity),
      listingExpDate: formatDateElement(listingExpDate),
      listingExpTime: listingExpTime,
      termsExpDate: termsDate,
      termsExpTime: termsTime,
      comment: comment,
      deliveryType: injectDrawl?.name,
      termsDocumentId: generalTermsConditions,
      isExBusBar: injectDrawl?.name === "Ex-Bus-Bar" ? true : false,
    };
    if (!editId) {
      setConfirmAddListingPayload(payload); // Store payload
      setConfirmAddListingModalOpen(true);
    } else {
      handleSubmit(payload, data);
    }
  };

  async function handleWithdrawBid(id) {
    try {
      setWithdrawBidLoading(true);
      const res = await withdrawBid({
        capacityConsumerId:
          activeRole.toLowerCase() === "consumer" ? id : activeCounrterId,
        capacityGeneratorId:
          activeRole.toLowerCase() === "consumer" ? activeCounrterId : id,
      });
      if (res?.data?.code === 200) {
        toast.success("Bid withdrawn successfully", toastProperties);
        handleClose();
        const payload = {
          id: id,
          energySourceType: "",
          energyFuelType: "",
          tag: "",
        };
        dispatch(
          fetchCounterPartList({
            user: activeRole.toLowerCase(),
            payload,
            curr: 0,
          }),
        );
      }
    } catch (error) {
      toast.error("Something went wrong", toastProperties);
    } finally {
      setWithdrawBidLoading(false);
    }
  }

  const handleReqStage = (value, status) => {
    setReqStage(value);
    setIsIntra(status);
    if (value === "greater_7") {
      setPaymentSecurity(4);
      setInitialMargin(100);
    }
  };

  // Update the handleRTCCheck function
  const handleRTCCheck = (index, checked) => {
    if (checked) {
      // When RTC is checked, set times to 00:00 and 24:00
      setRequirements((prev) =>
        prev.map((req, i) =>
          i === index
            ? { ...req, startTime: "00:00", endTime: "24:00", rtc: true }
            : req,
        ),
      );
    } else {
      // When RTC is unchecked, clear the times and set rtc to false
      setRequirements((prev) =>
        prev.map((req, i) =>
          i === index
            ? { ...req, startTime: "", endTime: "", rtc: false }
            : req,
        ),
      );
    }
  };

  function handleEdit() {
    if (!validateFields()) return;
    setConfirmEditModalOpen(true);
  }

  const headerDisabled =
    onHold || (editId && canUpdateListing) || loading || editId;

  // Render
  return (
    <>
      <ConfirmationModal
        open={confirmEditModalOpen}
        handleClose={() => setConfirmEditModalOpen(false)}
        handleSubmit={() => handleContinue()}
        header={"Edit Listing Confirmation"}
        data={
          "Updating key details may affect existing matches and connection requests. Are you sure you want to proceed?"
        }
        loading={loading}
      />
      <ConfirmationModal
        open={confirmWithdrawModalOpen}
        handleClose={() => setConfirmWithdrawModalOpen(false)}
        handleSubmit={() => handleWithdraw(editId)}
        header={"Withdraw Listing Confirmation"}
        data={
          "Withdrawing this listing will remove it from the platform. This cannot be undone. Do you want to continue?"
        }
        loading={withdrawLoading}
      />
      <ConfirmationModal
        open={confirmHoldModalOpen}
        handleClose={() => setConfirmHoldModalOpen(false)}
        handleSubmit={() => handleHold(editId)}
        header={"Hold Listing Confirmation"}
        data={
          "Putting this listing on hold will temporarily make it invisible to counterparties. Proceed?"
        }
        loading={holdLoading}
      />
      <ConfirmationModal
        open={confirmResumeModalOpen}
        handleClose={() => setConfirmResumeModalOpen(false)}
        handleSubmit={() => handleResume(editId)}
        header={"Release Listing Confirmation"}
        data={
          "Reactivating this listing will make it available to counterparties again. Do you want to continue?"
        }
        loading={resumeLoading}
      />

      <ConfirmationModal
        open={confirmWithdrawConnectionModalOpen}
        handleClose={() => setConfirmWithdrawConnectionModalOpen(false)}
        handleSubmit={() => handleWithdrawBid(editId)}
        header={"Withdraw Connection Confirmation"}
        data={
          "Are you sure you want to withdraw your request? The counterparty will be notified."
        }
        loading={withdrawBidLoading}
      />
      <ConfirmationModal
        open={confirmAddListingModalOpen}
        handleClose={() => setConfirmAddListingModalOpen(false)}
        handleSubmit={() => handleSubmit(confirmAddListingPayload)}
        header={"Add Listing Confirmation"}
        data={
          window.location.pathname.includes("/search_listing")
            ? "A new listing will be created & connection request will be sent. Do you want to continue?"
            : "A new listing will be created. Do you want to continue?"
        }
        loading={handleSubmitLoading || loading}
      />
      <PdfPreviewModal />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={Styles.ListingMainContainer}>
          <div className={Styles.conGenHeaderContainer}>
            <div>
              {editConnectionRequest ? (
                "Edit Connection Request"
              ) : (
                <>{editId ? "Edit Listing" : "Add Listing"}</>
              )}
            </div>
            <div className="display_flex_row_gap_8">
              <div
                className={`display_flex_row_center ${Styles.buttonSelectionContainer}`}
              >
                {[
                  // { id: "intraday", label: "Intraday", intra: true },
                  // { id: "nextday", label: "Next Day", intra: true },
                  // { id: "upto_7", label: "Next 7 days", intra: false },
                  // {
                  //   id: "greater_7",
                  //   label: "Custom",
                  //   intra: false,
                  // },
                ].map((st) => {
                  const active = reqStage === st.id;
                  const className = active
                    ? `${Styles.activereqStage} ${
                        headerDisabled ? Styles.disabled : ""
                      }`
                    : `${Styles.inActiveReqStage} ${
                        headerDisabled ? Styles.disabled : ""
                      }`;
                  return (
                    <div
                      key={st.id}
                      onClick={() =>
                        !headerDisabled && handleReqStage(st.id, st.intra)
                      }
                      className={className}
                      style={{
                        pointerEvents: headerDisabled ? "none" : "auto",
                        opacity: headerDisabled ? 0.6 : 1,
                        cursor: headerDisabled ? "not-allowed" : "pointer",
                      }}
                      aria-disabled={headerDisabled}
                    >
                      {st.label}
                    </div>
                  );
                })}
              </div>

              <Close
                onClick={handleClose}
                style={{
                  color: "#8C8A96",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          <div className={Styles.elementMainContainer}>
            <div className={Styles.excel_upload_main}>
              {
                  traderParent && (
                  <div>
                    <TextInput
                      value={entityName}
                      onChange={(value) =>
                        setEntityName(value)
                      }
                      type={"text"}
                      example={"Entity Name"}
                      height={35}
                    />
                  </div>
                  )
              }
              <div className={Styles.excelMainContainer}>
                {/* <div>
                  <Fileupload
                    accept={".xlsx"}
                    value={excelUpload}
                    onChange={handleExcelUpload}
                    example={"Upload Requirement file"}
                    fileType={"excel"}
                    id={"excel-upload"}
                  />
                </div> */}

                <div className={Styles.customFileUpload}>
                  <label
                    htmlFor="excelFileUpload"
                    className={Styles.uploadLabel}
                    style={{ cursor: "pointer" }}
                  >
                    {/* {selectedFileName ? (
                      <span className={Styles.uploadedFileName}>
                        <strong>{selectedFileName}</strong>
                      </span>
                    ) : (
                     
                    )} */}

                    <div className={Styles.uploadHeaderExcel}>
                      <span>
                        <Upload
                          width="28px"
                          height="28px"
                          display="flex"
                          justifyContent="right"
                        />
                      </span>
                      <span>Upload Template</span>
                    </div>
                  </label>
                  <input
                    id="excelFileUpload"
                    type="file"
                    accept=".xlsx,.xls"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const f = e.target.files?.[0];
                      handleExcelUpload(f);
                      e.target.value = ""; // allow re-uploading the same file
                    }}
                  />
                </div>
              </div>

              <div
                onClick={() => handleDownloadExcel()}
                className={`display_flex_row_gap_8 ${Styles.downloadButton}`}
              >
                <img src={FileDownloadIcon} alt="" />
                <span style={{ textWrap: "nowrap" }}>Template</span>
              </div>
            </div>

            <div className={Styles.level4Continaer}>
              <div className={Styles.radioContainer}>
                <div className={Styles.radioHeading}>
                  <span style={{ textWrap: "nowrap" }}>
                    {" "}
                    Energy Requirement{" "}
                  </span>
                  <div className={Styles.radioList}>
                    {energyReqList?.map((ele) => {
                      const isDisabled = activeRole === "GENERATOR";
                      return (
                        <div
                          key={ele.id}
                          className={
                            ele?.id === energyReq?.id
                              ? `${Styles.radioReqContActive} ${
                                  isDisabled ? Styles.disabled : ""
                                }`
                              : `${Styles.radioReqCont} ${
                                  isDisabled ? Styles.disabled : ""
                                }`
                          }
                          onClick={() => {
                            if (!isDisabled) handleEnergyReqChange(ele);
                          }}
                          title={ele?.name}
                          style={{
                            pointerEvents: isDisabled ? "none" : "auto",
                            opacity: isDisabled ? 0.6 : 1,
                            cursor: isDisabled ? "not-allowed" : "pointer",
                          }}
                          aria-disabled={isDisabled}
                        >
                          {ele?.name}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div>
                  {energyList && (
                    <SelectInput
                      list={
                        energyReq?.name === "Any"
                          ? [{ id: 16, genType: "RENEWABLE", type: "Any" }]
                          : energyList?.filter(
                              (ele) =>
                                ele?.genType === energyReq?.value &&
                                ele?.type !== "Other",
                            )
                      }
                      disabled={activeRole === "GENERATOR"}
                      onChange={handleEnergyTypeChange}
                      example={"Select Energy Type"}
                      value={energyType}
                      height={35}
                      defaultVal={energyType}
                    />
                  )}
                  {(errors.energyType || errors.energyReq) && (
                    <div className={Styles.error}>
                      Energy Type & Requirement is required
                    </div>
                  )}
                </div>
              </div>

              <div>
                {regionList && (
                  <SelectInput
                    disabled={activeRole === "GENERATOR"}
                    list={regionList}
                    onChange={handleRegionChange}
                    example={"Select Region"}
                    heading={"Region*"}
                    value={region}
                    height={35}
                    defaultVal={region}
                  />
                )}
                {errors.region && (
                  <div className={Styles.error}>{errors.region}</div>
                )}
              </div>

              <div>
                <div style={{ gap: "6px" }} className={Styles.radioContainer}>
                  <div>
                    <div className={Styles.radioHeading}>
                      <span style={{ whiteSpace: "nowrap" }}>
                        Delivery Type / Point Of{" "}
                        {activeRole === "CONSUMER" ? "Drawal" : "Injection"} *
                      </span>
                      <div className={Styles.radioList}>
                        {injDrawl?.map((ele) => (
                          <div
                            key={ele.id}
                            className={
                              ele?.id === injectDrawl?.id
                                ? Styles.radioReqContActive
                                : Styles.radioReqCont
                            }
                            onClick={() => {
                              if (onHold) {
                                return;
                              }
                              setInjectDrawl(ele);
                            }}
                            title={ele?.name}
                          >
                            {ele?.name}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      className={Styles.radioList}
                      style={{
                        marginTop: "0px",
                        height: "32px",
                        borderRadius: "8px",
                      }}
                    >
                      {deliveryTypeList?.map((ele, i) => (
                        <div
                          style={{
                            height: "27px",
                            borderRadius: "8px",
                            border: "0px",
                            fontSize: "11px",
                            borderRight: i === 0 ? "1px solid #E0E0E0" : "0px",
                          }}
                          key={ele.id}
                          className={
                            ele?.id === deliveryType?.id
                              ? Styles.radioReqContActive
                              : Styles.radioReqCont
                          }
                          onClick={() => {
                            if (onHold) {
                              return;
                            }
                            setDeliveryType(ele);
                            setVoltage(null);
                          }}
                          title={ele?.name}
                        >
                          {ele?.name}
                        </div>
                      ))}
                    </div>
                    {(errors.deliveryType || errors.injectDrawl) && (
                      <div className={Styles.error}>
                        Delivery & Drawal/Injection is required
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div>
                {voltageList && (
                  <SelectInput
                    list={getFilteredVoltageList(deliveryType, voltageList)}
                    onChange={handleVoltageChange}
                    example={"Select Voltage Level"}
                    heading={"Voltage Level *"}
                    value={voltage}
                    height={35}
                  />
                )}
                {errors.voltage && (
                  <div className={Styles.error}>{errors.voltage}</div>
                )}
              </div>
            </div>
            <div className={Styles.multiListingMain}>
              {requirements?.map((ele, index) => {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const tomorrow = new Date(today);
                tomorrow.setDate(today.getDate() + 1);
                const upto7 = new Date(today);
                upto7.setDate(today.getDate() + 6);
                // allow greater_7 from today; end date must be >= today + 7
                const greater7EndMin = new Date(today);
                greater7EndMin.setDate(today.getDate() + 7);
                // New: bounds for "Next 7 days" end-date selection
                const dayAfterTomorrow = new Date(today);
                dayAfterTomorrow.setDate(today.getDate() + 2);
                const next7EndMax = new Date(today);
                next7EndMax.setDate(today.getDate() + 6);
                const greaterthan7 = new Date(today);
                greaterthan7.setDate(today.getDate() + 4);

                return (
                  <div>
                    <div className={Styles.sectionHeading}>
                      Requisition {index + 1}
                    </div>
                    <div
                      key={index}
                      className={Styles.startDateRequirementMain}
                    >
                      <div className={Styles.multiListingContainer}>
                        <div className={Styles.layer6Container}>
                          <div style={{ marginTop: "4px" }}>
                            <DateInput
                              heading={"Start Date *"}
                              value={requirements[index]?.startDate}
                              onChange={(value) =>
                                handleRequirementChange(
                                  index,
                                  "startDate",
                                  value,
                                )
                              }
                              minDate={
                                reqStage === "intraday"
                                  ? today
                                  : reqStage === "nextday"
                                    ? tomorrow
                                    : reqStage === "upto_7"
                                      ? today
                                      : reqStage === "greater_7"
                                        ? greaterthan7
                                        : new Date()
                              }
                              maxDate={
                                reqStage === "intraday"
                                  ? today
                                  : reqStage === "nextday"
                                    ? tomorrow
                                    : reqStage === "upto_7"
                                      ? upto7
                                      : undefined
                              }
                              height={35}
                            />
                            {errors[`startDate_${index}`] && (
                              <div className={Styles.error}>
                                {errors[`startDate_${index}`]}
                              </div>
                            )}
                          </div>
                          <div style={{ marginTop: "4px" }}>
                            <DateInput
                              heading={"End Date *"}
                              value={requirements[index]?.endDate}
                              onChange={(value) =>
                                handleRequirementChange(index, "endDate", value)
                              }
                              minDate={
                                reqStage === "intraday"
                                  ? today
                                  : reqStage === "nextday"
                                    ? tomorrow
                                    : reqStage === "upto_7"
                                      ? dayAfterTomorrow
                                      : reqStage === "greater_7"
                                        ? greaterthan7
                                        : requirements[index]?.startDate
                              }
                              maxDate={
                                reqStage === "intraday"
                                  ? today
                                  : reqStage === "nextday"
                                    ? tomorrow
                                    : reqStage === "upto_7"
                                      ? next7EndMax
                                      : undefined
                              }
                              height={35}
                            />
                            {errors[`endDate_${index}`] && (
                              <div className={Styles.error}>
                                {errors[`endDate_${index}`]}
                              </div>
                            )}
                          </div>
                          <div style={{ marginTop: "1px" }}>
                            <TimeInput
                              isRtc={requirements[index]?.rtc} // Use the rtc property from state
                              rtcButton={reqStage !== "intraday"}
                              handleRTC={(checked) =>
                                handleRTCCheck(index, checked)
                              }
                              type={"startTime"}
                              heading={"Start Time *"}
                              value={formatSlotTime(
                                requirements[index]?.startTime,
                              )}
                              onChange={(value) =>
                                handleRequirementChange(
                                  index,
                                  "startTime",
                                  value,
                                )
                              }
                              startDate={requirements[index]?.startDate}
                              minutesStep={15}
                              height={35}
                              disabled={
                                requirements[index]?.rtc &&
                                reqStage !== "intraday"
                              }
                            />
                            {errors[`startTime_${index}`] && (
                              <div className={Styles.error}>
                                {errors[`startTime_${index}`]}
                              </div>
                            )}
                          </div>
                          <div style={{ marginTop: "1px" }}>
                            <TimeInput
                              isRtc={requirements[index]?.rtc} // Use the rtc property from state
                              type={"endTime"}
                              heading={"End Time *"}
                              value={formatSlotTime(
                                requirements[index]?.endTime,
                              )}
                              onChange={(value) =>
                                handleRequirementChange(index, "endTime", value)
                              }
                              minutesStep={15}
                              height={35}
                              startTime={requirements[index]?.startTime}
                              disabled={
                                requirements[index]?.rtc &&
                                reqStage !== "intraday"
                              }
                            />
                            {errors[`endTime_${index}`] && (
                              <div className={Styles.error}>
                                {errors[`endTime_${index}`]}
                              </div>
                            )}
                          </div>
                          <div>
                            <TextInput
                              heading={"Quantity (MW) *"}
                              value={requirements[index]?.quantity}
                              onChange={(value) =>
                                handleRequirementChange(
                                  index,
                                  "quantity",
                                  value,
                                )
                              }
                              type={"number"}
                              example={"Eg. 400"}
                              height={35}
                            />
                            {errors[`quantity_${index}`] && (
                              <div className={Styles.error}>
                                {errors[`quantity_${index}`]}
                              </div>
                            )}
                          </div>
                          <div style={{ width: "22%", position: "relative" }}>
                            <div
                              style={{ marginBottom: "5px" }}
                              className={Styles.radioHeading}
                            >
                              <span style={{ textWrap: "nowrap" }}>
                                Energy Rate *
                              </span>
                              <div className={Styles.radioList}>
                                {EnergyRateList?.map((ele) => (
                                  <div
                                    key={ele.id}
                                    className={
                                      ele?.id ===
                                      requirements[index]?.energyRateType?.id
                                        ? Styles.radioReqContActive
                                        : Styles.radioReqCont
                                    }
                                    onClick={() => {
                                      if (onHold) return;
                                      handleRequirementChange(
                                        index,
                                        "energyRateType",
                                        ele,
                                      );
                                    }}
                                    title={ele?.name}
                                  >
                                    {ele?.name}
                                  </div>
                                ))}
                              </div>
                            </div>

                            {requirements[index]?.energyRateType?.name !==
                              "Fixed" && (
                              <span
                                style={{
                                  position: "absolute",
                                  zIndex: 9999,
                                  left: "10px",
                                  top: "33px",
                                  fontSize: "12px",
                                  color: "var(--fifth-color-text)",
                                }}
                              >
                                {requirements[index]?.energyRateType?.name}
                              </span>
                            )}
                            <TextInput
                              min={0}
                              inputStyle={{
                                paddingLeft:
                                  requirements[index]?.energyRateType?.name !==
                                  "Fixed"
                                    ? "53px"
                                    : "10px",
                              }}
                              value={requirements[index]?.energyRate}
                              onChange={(value) =>
                                handleRequirementChange(
                                  index,
                                  "energyRate",
                                  value,
                                )
                              }
                              type={"number"}
                              example={"Eg. 10"}
                              height={35}
                            />

                            <span
                              style={{
                                position: "absolute",
                                right: "1px",
                                top: "24px",
                                padding: "10px 6px",
                                background: "#F3F3F4",
                                fontSize: "10px",
                                borderRadius: "5px",
                                color: "var(--fifth-color-text)",
                              }}
                            >
                              ₹/kWh
                            </span>

                            {errors[`energyRate_${index}`] && (
                              <div className={Styles.error}>
                                {errors[`energyRate_${index}`]}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className={Styles.alterButtonContainer}>
                        {requirements?.length > 1 && (
                          <div
                            onClick={() => handleRemoveRequirement(index)}
                            style={{ cursor: "pointer" }}
                          >
                            <DeleteIcon style={{ fontSize: 16 }} />
                          </div>
                        )}
                        <div
                          onClick={handleAddRequirement}
                          style={{ cursor: "pointer" }}
                        >
                          <AddIcon style={{ fontSize: 16 }} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {/* <div className={Styles.level4Continaer}>
              <div style={{ marginTop: "4px" }}>
                <TextInput
                  disabled={
                    reqStage === "intraday" ||
                    reqStage === "nextday" ||
                    reqStage === "upto_7" ||
                    reqStage === "greater_7"
                  }
                  info={
                    <span style={{ whiteSpace: "pre-line" }}>
                      <strong>Seller’s EMD:</strong> An amount of ₹30,000 per MW
                      or ₹1,00,000, whichever is lower, shall be deducted.
                      <br />
                      <br />
                      <strong>Buyer's EMD:</strong> 0
                    </span>
                  }
                  value={emd}
                  onChange={(value) => handleEMDChange(value)}
                  type={"number"}
                  example={"Eg. 60"}
                  heading={"EMD (₹/MW) *"}
                  height={35}
                />
                {errors.emd && <div className={Styles.error}>{errors.emd}</div>}
              </div>
              <div style={{ marginTop: "4px" }}>
                <TextInput
                  disabled={
                    reqStage === "intraday" ||
                    reqStage === "nextday" ||
                    reqStage === "upto_7" ||
                    reqStage === "greater_7"
                  }
                  info={
                    <span style={{ whiteSpace: "pre-line" }}>
                      <strong>Buyer’s Initial Margin</strong>: The percentage of
                      the total transaction value required to be deposited by
                      the Buyer for a single day.
                      <br />
                      <br />
                      <strong>Seller’s Initial Margin</strong>: A fixed margin
                      equivalent to 20% of the total transaction value, to be
                      deposited by the Seller for a single day.
                    </span>
                  }
                  min={100}
                  max={200}
                  value={initialMargin}
                  onChange={(value) => handleInitialMarginChange(value)}
                  type={"number"}
                  heading={"Initial Margin (%) *"}
                  example={"Eg. 100"}
                  height={35}
                />
                {errors.initialMargin && (
                  <div className={Styles.error}>{errors.initialMargin}</div>
                )}
              </div>

              <div style={{ marginTop: "4px" }}>
                <TextInput
                  heading={"Payment Security (# Days) *"}
                  disabled={
                    reqStage === "intraday" ||
                    reqStage === "nextday" ||
                    reqStage === "upto_7" ||
                    reqStage === "greater_7"
                  }
                  info={
                    <span style={{ whiteSpace: "pre-line" }}>
                      <strong>Buyer’s Payment Security:</strong> Calculated as
                      the Buyer’s Initial Margin multiplied by the transaction
                      value for one trading day and the number of days of
                      payment security.
                      <br />
                      <br />
                      <strong>Seller’s Payment Security:</strong> Sellers’
                      initial margin will be considered as payment security.
                    </span>
                  }
                  isInteger={true}
                  value={paymentSecurity}
                  onChange={(value) => handlePaymentSecurityChange(value)}
                  type={"number"}
                  example={"Eg. 60"}
                  height={35}
                />
                {errors.paymentSecurity && (
                  <div className={Styles.error}>{errors.paymentSecurity}</div>
                )}
              </div>
              <div>
                <div style={{ marginTop: "4px" }}>
                  <Fileupload
                    accept={".pdf"}
                    id={"general-terms-conditions"}
                    value={generalTermsConditions}
                    onChange={handleGeneralTermsConditions}
                    height={"35"}
                    heading={"Upload General T&C "}
                    example={
                      generalTermsConditions &&
                      typeof generalTermsConditions === "object" &&
                      generalTermsConditions.name
                        ? generalTermsConditions.name
                        : "Upload T&C (.pdf)"
                    }
                    fileType={"pdf"}
                  />
                </div>
              </div>
            </div> */}
            <>
              <div className={Styles.level5Wrapper}>
                <div className={Styles.level5Continaer}>
                  <div>
                    <div>
                      <Fileupload
                        accept={".pdf"}
                        id={"general-terms-conditions"}
                        value={generalTermsConditions}
                        onChange={handleGeneralTermsConditions}
                        height={"35"}
                        heading={"Upload General T&C "}
                        example={
                          generalTermsConditions &&
                          typeof generalTermsConditions === "object" &&
                          generalTermsConditions.name
                            ? generalTermsConditions.name
                            : "Upload T&C (.pdf)"
                        }
                        fileType={"pdf"}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "4px" }}>
                    <DateInput
                      isCustom={reqStage === "greater_7"}
                      disabled={editId ? true : false}
                      heading={"Listing Expiry Date *"}
                      value={listingExpDate}
                      onChange={handleListingExpDateChange}
                      minDate={new Date()}
                      maxDate={getListingExpiryMaxDateTime()}
                      height={35}
                    />
                    {errors.listingExpDate && (
                      <div className={Styles.error}>
                        {errors.listingExpDate}
                      </div>
                    )}
                  </div>
                  <div>
                    <TimeInput
                      disabled={onHold || editId ? true : false}
                      type={"listingExpTime"}
                      heading={"Listing Expiry Time *"}
                      value={formatSlotTime(listingExpTime)}
                      onChange={handleListingExpTimeChange}
                      minutesStep={15}
                      height={35}
                      endTime={
                        listingExpDate &&
                        getListingExpiryMaxDateTime() &&
                        new Date(listingExpDate).toDateString() ===
                          getListingExpiryMaxDateTime().toDateString()
                          ? getListingExpiryMaxDateTime()
                              .toTimeString()
                              .slice(0, 5)
                          : undefined
                      }
                      maxTime={reqStage === "nextday" ? "22:00" : undefined}
                    />
                    {errors.listingExpTime && (
                      <div className={Styles.error}>
                        {errors.listingExpTime}
                      </div>
                    )}
                  </div>
                  {/* <div>
                    <DateInput
                      disabled={onHold || editId ? true : false}
                      heading={"Terms Expiry Date"}
                      value={termsExpDate}
                      onChange={handleTermsExpDateChange}
                      minDate={new Date()}
                      maxDate={getListingExpiryMaxDateTime()}
                      height={35}
                    />
                    {errors.termsExpDate && (
                      <div className={Styles.error}>{errors.termsExpDate}</div>
                    )}
                  </div>

                  <div>
                    <TimeInput
                      disabled={onHold || editId ? true : false}
                      heading={"Terms Expiry Time"}
                      value={formatSlotTime(termsExpTime)}
                      onChange={handleTermsExpTimeChange}
                      minutesStep={15}
                      height={35}
                      endTime={
                        termsExpDate &&
                        getListingExpiryMaxDateTime() &&
                        new Date(termsExpDate).toDateString() ===
                          getListingExpiryMaxDateTime().toDateString()
                          ? getListingExpiryMaxDateTime()
                              .toTimeString()
                              .slice(0, 5)
                          : undefined
                      }
                      maxTime={reqStage === "nextday" ? "22:00" : undefined}
                    />
                    {errors.termsExpTime && (
                      <div className={Styles.error}>{errors.termsExpTime}</div>
                    )}
                  </div> */}

                  <div style={{ width: "150rem" }}>
                    <TextInput
                      heading={"Comment"}
                      value={comment}
                      onChange={handleCommentChange}
                      type={"text"}
                      example={"Enter Comment"}
                      height={35}
                      width={"100%"}
                    />
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "10px",
                    color: "var(--fifth-color-text)",
                  }}
                >
                  *Expiry date/time cannot be edited once the listing is
                  created.
                </span>
                <div>
                  <span
                    style={{
                      fontSize: "10px",
                      color: "var(--fifth-color-text)",
                    }}
                  >
                    {`*Listing terms and conditions can be finalized upto 3 ${reqStage === "greater_7" ? "days" : "hours"}
                    before the start of the first schedule (subject to
                    applicable regulations).`}
                  </span>
                </div>
              </div>
            </>
            {/* <div className={Styles.level1Continaer}>
              <div>
                <TextInput
                  heading={"Comment"}
                  value={comment}
                  onChange={handleCommentChange}
                  type={"text"}
                  example={"Enter Comment"}
                  height={35}
                />
              </div>
            </div> */}

            {!editId && (
              <div className={Styles.level6Continaer}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",

                    fontSize: "12px",
                    color: "#8C8A96",
                    fontWeight: 400,
                  }}
                >
                  <input
                    type="checkbox"
                    style={{ marginRight: "8px" }}
                    checked={acceptSystemTerms}
                    onChange={(e) => setAcceptSystemTerms(e.target.checked)}
                  />
                  I Understand and Accept&nbsp;
                  <span
                    onClick={() => {
                      handlePreviewGeneralTerms(
                        "https://gna-general-files.s3.ap-south-1.amazonaws.com/Website+Assets+PDF/GNA-bye-laws.pdf",
                        {
                          hideHeader: true,
                        },
                      );
                    }}
                    type="button"
                    style={{
                      color: "#ff9800",
                      cursor: "pointer",
                    }}
                  >
                    System Terms and Condition
                  </span>
                  {directConnect && data.termsDocumentId && (
                    <>
                      &nbsp; <span>and</span>&nbsp;
                      <span
                        onClick={() => {
                          handlePreviewGeneralTerms(data.termsDocumentId, {
                            hideHeader: true,
                          });
                        }}
                        type="button"
                        style={{
                          color: "#ff9800",
                          cursor: "pointer",
                        }}
                      >
                        General Terms and Condition
                      </span>
                    </>
                  )}
                </div>

                {termsError && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "8px" }}
                  >
                    {termsError}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={Styles.submitButtonArea}>
            <button className={Styles.cancelButton} onClick={handleClose}>
              Cancel
            </button>

            {editId && !editConnectionRequest && (
              <>
                <button
                  disabled={withdrawLoading || onHold}
                  className={Styles.withdrawButton}
                  onClick={() => {
                    setConfirmWithdrawModalOpen(true);
                  }}
                >
                  {withdrawLoading ? "Withdrawing..." : "Withdraw"}
                </button>

                {data.status === "HOLD" ? (
                  <button
                    disabled={resumeLoading}
                    className={Styles.holdButton}
                    onClick={() => {
                      setConfirmResumeModalOpen(true);
                    }}
                  >
                    {resumeLoading ? "Releasing..." : "Release"}
                  </button>
                ) : (
                  <button
                    disabled={holdLoading}
                    className={Styles.holdButton}
                    onClick={() => {
                      setConfirmHoldModalOpen(true);
                    }}
                  >
                    {holdLoading ? "Holding..." : "Hold"}
                  </button>
                )}
              </>
            )}

            {editConnectionRequest && (
              <button
                disabled={withdrawBidLoading || onHold}
                className={Styles.withdrawButton}
                onClick={() => {
                  setConfirmWithdrawConnectionModalOpen(true);
                }}
              >
                {withdrawBidLoading ? "Withdrawing..." : "Withdraw "}
              </button>
            )}
            <button
              title={
                editId &&
                canUpdateListing &&
                "Cannot edit listing after terms are initiated or accepted"
              }
              disabled={loading || onHold || (editId && canUpdateListing)}
              className={Styles.submitButton}
              onClick={() => {
                editId ? handleEdit() : handleContinue();
              }}
            >
              {loading
                ? "Submitting..."
                : editId
                  ? "Update"
                  : directConnect
                    ? "Connect"
                    : "Submit"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConGenListingModal;
